import { sitesService } from '../../_services/sites.service';
import { readSitesCache, loadSites, groupSites } from './useSites';
import { resolveScopeSalonIds } from './LocationScope';
import toast from '../shared/Toast';

/**
 * After a catalogue save: push the item to the sites the Locations control
 * chose. Best-effort and quiet on "this location" — the save already happened.
 */
export async function syncCatalogueAfterSave(type, id, scope) {
    try {
        if (!scope || scope.mode === 'this' || !id) return null;
        const d = readSitesCache() || await loadSites(false);
        // Group sites only: an SE at two unrelated salons has two sites and no
        // group, and must never see a sync error for a save that worked.
        const sites = groupSites(d);
        if (sites.length < 2) return null;
        const active = sites.find((s) => s.isActive);
        const ids = resolveScopeSalonIds(scope, sites, active && active.salonId);
        if (!ids.length) return null;
        const r = await sitesService.syncCatalogue(type, id, ids);
        const c = (r && r.created) || [], u = (r && r.updated) || [], k = (r && r.skipped) || [];
        const bits = [];
        if (c.length) bits.push(`added at ${c.map((x) => x.salonName).join(', ')}`);
        if (u.length) bits.push(`updated at ${u.map((x) => x.salonName).join(', ')}`);
        if (k.length) bits.push(`skipped ${k.map((x) => x.salonName).join(', ')}`);
        if (bits.length) toast.success(`Also ${bits.join('; ')}`);
        return r;
    } catch (e) {
        toast.error((e && e.message) || 'Could not copy to other locations');
        return null;
    }
}
